import { Injectable } from '@angular/core';
import { MenuItem } from '@app/core/models';

/**
 * NavigationService
 */
@Injectable({ providedIn: 'root' })
export class NavigationService {
  /**
   * constructor
   */
  constructor() {}

  /**
   * filter
   * @param {MenuItem[]} items
   * @param {ApplicationProfile[]} profiles
   * @returns {MenuItem[]}
   */
  filter(items: MenuItem[], profiles: string[]): MenuItem[] {
    return items.reduce((acc, item) => {
      const { entitlement } = item;

      if (item.children) {
        item = Object.assign({}, item, {
          children: this.filter(item.children, profiles),
        });
      }

      if (entitlement) {
        const application: string = profiles.filter(
          (profile: string) => profile === entitlement,
        )[0];

        // if (!application || !entitlement.status.includes(application.status)) {
        //   return acc;
        // }
      }

      return [...acc, item];
    }, []);
  }
}
